import React from "react";
import AboutUsHeader from "../organisms/AboutUsHeader";
import AboutUsBody from "../organisms/AboutUsBody";
import Footer from "../organisms/Footer";
import useScrollToTop from "../../hooks/useScrollToTop"
const AboutUsPage = () => {
  useScrollToTop()
  return (
    <div className="bg-gray-100">
      <AboutUsHeader />
      <AboutUsBody />
      <Footer />
    </div>
  );
};

export default AboutUsPage;
